import SceneSetVideo from '../Video';

const SceneSetAudio = SceneSetVideo;

export default SceneSetAudio;
